// extracted by mini-css-extract-plugin
module.exports = {"photoswipeGallery":"photoswipe-gallery-view_photoswipeGallery__Fyn-u","list":"photoswipe-gallery-view_list__3CZy4","item":"photoswipe-gallery-view_item__2lkeU"};